<template>
  <div>
    <v-dialog
      v-model="dialogTache"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <Loading :value="loading"></Loading>
      <v-card tile>
        <v-toolbar card dark color="primary">
          <v-toolbar-title
            >LISTE DES TACHES POUR LES TRAVAUX :
            {{ detailTrx.libelle }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="closeDialog()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <!-- TAB CHANTIER -->
        <v-layout row>
          <v-flex sm12>
            <v-layout row>
              <v-flex sm12 ml-2 mr-2 mt-5>
                <v-card>
                  <data-tables
                    mt-3
                    ml-1
                    mr-1
                    :data="listeTache"
                    style="width:99%;"
                  >
                    <el-table-column
                      prop="libelle"
                      label="TACHES"
                      align="center"
                      width="230"
                      fixed
                    ></el-table-column>
                    <el-table-column label="DATE" align="center">
                      <el-table-column
                        prop="dateD"
                        label="Début"
                      ></el-table-column>
                      <el-table-column
                        prop="dateF"
                        label="Fin"
                      ></el-table-column>
                      <el-table-column
                        prop="duree"
                        label="Durée (Jours) "
                      ></el-table-column>
                    </el-table-column>
                    <el-table-column
                      prop="dateDemarage"
                      label="Demarré le"
                    ></el-table-column>

                    <el-table-column
                      prop="libEtat"
                      label="STATUS"
                      align="center"
                    ></el-table-column>
                    <el-table-column
                      label="ACTION"
                      align="center"
                      width="250"
                      fixed="right"
                      v-if="!commis"
                    >
                      <template slot-scope="scope">
                        <v-tooltip bottom>
                          <v-tooltip bottom>
                            <v-btn
                              @click="
                                tacheSelect = scope.row;
                                loadOuvrier(scope.row);
                              "
                              slot="activator"
                              icons
                              color="blue"
                              fab
                              dark
                              small
                            >
                              <v-icon>assignment_ind</v-icon>
                            </v-btn>
                            <span>ouvriers</span>
                          </v-tooltip>

                          <v-tooltip bottom>
                            <v-btn
                              @click="showDialogReserve(scope.row)"
                              v-if="
                                scope.row.prestataire == true &&
                                  scope.row.etat != 0
                              "
                              slot="activator"
                              icons
                              color="orange"
                              fab
                              dark
                              small
                            >
                              <v-icon>announcement</v-icon>
                            </v-btn>
                            <span>reserve</span>
                          </v-tooltip>

                          <!-- / les ouvriers sont affecté par le respo chantier, donc les contrats sont fait par chantier -->
                          <!-- <v-btn
                          v-if="scope.row.prestataire == false"
                          slot="activator"
                          outline
                          color="orange"
                          dark
                          small
                        >Aucun ouvriers ou prestataires !</v-btn> -->
                          <v-btn v-if="scope.row.etat == 0"
                            @click.native="
                              tacheSelect = scope.row;
                              dialogDemarrer = true;
                            "
                            slot="activator"
                            icons
                            color="green"
                            fab
                            dark
                            small
                          >
                            <v-icon>play_circle_outline</v-icon> </v-btn
                          >Démarrer
                        </v-tooltip>

                        <v-tooltip bottom>
                          <v-btn
                            v-if="scope.row.etat == 3 "
                            @click.native="
                              tacheSelect = scope.row;
                              submitRelanceTache();
                            "
                            slot="activator"
                            icons
                            color="orange"
                            fab
                            dark
                            small
                          >
                            <v-icon>play_circle_outline</v-icon> </v-btn
                          >Relancer
                        </v-tooltip>

                        <v-tooltip bottom>
                          <v-btn
                            v-if="scope.row.etat == 1"
                            @click.native="
                              tacheSelect = scope.row;
                              dialogConfirmRefus = true;
                            "
                            slot="activator"
                            icons
                            color="red"
                            fab
                            dark
                            small
                          >
                            <v-icon>stop</v-icon> </v-btn
                          >Suspendre
                        </v-tooltip>

                        <v-tooltip bottom>
                          <v-btn
                            v-if="!scope.row.etat == 2"
                            @click.native="
                              tacheSelect = scope.row;
                              dialogTermine = true;
                            "
                            slot="activator"
                            icons
                            color="green"
                            fab
                            dark
                            small
                          >
                            <v-icon>done_all</v-icon> </v-btn
                          >Terminer
                        </v-tooltip>

                        <!-- <v-chip
                        v-if="scope.row.prestataire == false"
                        label
                        text-color="white"
                        color="red"
                        >Aucun ouvrier ou prestataire</v-chip>-->
                      </template>
                    </el-table-column>
                  </data-tables>
                  <br />
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <!--FIN  TAB CHANTIER -->
      </v-card>

      <!--MODAL LISTE OUVRIERS -->
      <v-dialog
        v-model="dialogOuvrier"
        :persistent="true"
        width="90%"
        scrollable
      >
        <v-card tile>
          <v-toolbar card dark color="primary">
            <v-toolbar-title
              >LISTE DES OUVRIERS ET PRESTATAIRE AFFECTES A LA TACHE:
              {{ tacheSelect.libelle }}</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-btn icon dark @click.native="dialogOuvrier = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <h4 mt-2>LISTE DES OUVRIERS</h4>
            <v-divider></v-divider>
            <v-layout row elevation-2>
              <v-flex sm12 mt-2>
                <data-tables
                  mt-3
                  ml-1
                  mr-1
                  :data="listeOuvriers"
                  style="width:99%;"
                >
                  <el-table-column
                    prop="idContrat"
                    label="Contrat"
                    align="center"
                    width="100"
                    fixed
                  >
                    <template slot-scope="scope"
                      >CONT-{{ scope.row.idContrat }}</template
                    >
                  </el-table-column>
                  <el-table-column
                    prop="nom"
                    label="NOM"
                    align="center"
                    width="230"
                    fixed
                  ></el-table-column>
                  <el-table-column
                    prop="dateC"
                    label="DATE"
                    align="center"
                  ></el-table-column>
                  <el-table-column prop="dateD" label="Début"></el-table-column>
                  <el-table-column prop="dateF" label="Fin"></el-table-column>
                  <el-table-column
                    prop="duree"
                    label="Durée (Jours) "
                  ></el-table-column>
                  <el-table-column
                    prop="etatContrat"
                    label="Etat contrat"
                    align="center"
                  ></el-table-column>
                </data-tables>
              </v-flex>
            </v-layout>
            <br />
            <h4 mt-2>LISTE DES PRESTATAIRES</h4>
            <v-divider></v-divider>
            <v-layout row elevation-2>
              <v-flex sm12 mt-2>
                <data-tables
                  mt-3
                  ml-1
                  mr-1
                  :data="listePrestataires"
                  style="width:99%;"
                >
                  <el-table-column
                    prop="idContrat"
                    label="Contrat"
                    align="center"
                    width="100"
                    fixed
                  >
                    <template slot-scope="scope"
                      >CONT-{{ scope.row.idContrat }}</template
                    >
                  </el-table-column>
                  <el-table-column
                    prop="nom"
                    label="NOM"
                    align="center"
                    width="230"
                    fixed
                  ></el-table-column>
                  <el-table-column
                    prop="dateC"
                    label="DATE"
                    align="center"
                  ></el-table-column>
                  <el-table-column prop="dateD" label="Début"></el-table-column>
                  <el-table-column prop="dateF" label="Fin"></el-table-column>
                  <el-table-column
                    prop="duree"
                    label="Durée (Jours) "
                  ></el-table-column>
                  <el-table-column
                    prop="etatContrat"
                    label="Etat contrat"
                    align="center"
                  ></el-table-column>
                </data-tables>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>

            <br />

            <!--ENREGISTRER UN PRESENCE -->
            <!--<v-layout row>-->
            <!--<v-flex xs12 ml-2 mr-2>-->
            <!--<v-card>-->
            <!--<v-flex xs12 class="mb-2 ml-2 mr-2">-->
            <!--<v-alert-->
            <!--:value="true"-->
            <!--outline-->
            <!--color="purple"-->
            <!--icon="info"-->
            <!--&gt;Liste de présence (Cette liste ne peut pas être modifiée si la tache est terminée)</v-alert>-->
            <!--</v-flex>-->
            <!--<el-form-->
            <!--id="prestataireSelect"-->
            <!--label-position="top"-->
            <!--:inline="true"-->
            <!--:model="prestataireSelect"-->
            <!--:ref="prestataireSelect"-->
            <!--class="demo-form-inline"-->
            <!--&gt;-->
            <!--<v-layout row>-->
            <!--<v-flex md3>-->
            <!--<el-form-item label="Nom" prop="nom">-->
            <!--<el-select-->
            <!--filterable-->
            <!--style="width:100%"-->
            <!--v-model="prestataireSelect.idContrat"-->
            <!--placeholder="Select"-->
            <!--&gt;-->
            <!--<el-option-->
            <!--v-for="item in listePrestOuvriers"-->
            <!--:key="item.id"-->
            <!--:label="item.nom"-->
            <!--:value="item.idContrat"-->
            <!--&gt;</el-option>-->
            <!--</el-select>-->
            <!--</el-form-item>-->
            <!--</v-flex>-->

            <!--<v-flex md6>-->
            <!--<el-form-item label="Date *" style="width: 100%">-->
            <!--<el-date-picker-->
            <!--style="width: 100%"-->
            <!--v-model="prestataireSelect.datePresence"-->
            <!--format="dd-MM-yyyy HH:mm"-->
            <!--value-format="yyyy-MM-dd HH:mm"-->
            <!--type="datetimerange"-->
            <!--range-separator="à"-->
            <!--start-placeholder="Début date"-->
            <!--end-placeholder="Fin date"-->
            <!--&gt;</el-date-picker>-->
            <!--</el-form-item>-->
            <!--</v-flex>-->

            <!--<v-flex md1>-->
            <!--<el-form-item label="Action">-->
            <!--<el-button type="primary" @click="submitPresence()">Ajouter</el-button>-->
            <!--</el-form-item>-->
            <!--</v-flex>-->
            <!--</v-layout>-->
            <!--<v-layout row>-->
            <!--<v-flex md3>-->
            <!--<v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4">-->
            <!--<img :src="imageRes" alt="avatar" />-->
            <!--</v-avatar>-->
            <!--<v-layout row>-->
            <!--<input-->
            <!--name="fileRes"-->
            <!--type="file"-->
            <!--style="display:none"-->
            <!--ref="fileRes"-->
            <!--accept="image/*"-->
            <!--@change="onFileResPicked"-->
            <!--/>-->
            <!--<v-tooltip bottom>-->
            <!--<v-btn-->
            <!--slot="activator"-->
            <!--color="primary"-->
            <!--class="white&#45;&#45;text"-->
            <!--required-->
            <!--@click.native="$refs.fileRes.click()"-->
            <!--&gt;-->
            <!--Piece jointe-->
            <!--<v-icon right dark>cloud_upload</v-icon>-->
            <!--</v-btn>-->
            <!--<span>Taille inférieur à 1024 ko</span>-->
            <!--</v-tooltip>-->
            <!--</v-layout>-->
            <!--</v-flex>-->
            <!--</v-layout>-->
            <!--</el-form>-->
            <!--<v-spacer></v-spacer>-->
            <!--<br />-->

            <!--<v-layout row class="ml-2 mr-2">-->
            <!--<el-table :data="listePresence" style="width: 100%">-->
            <!--<el-table-column prop="idContrat" label="Contrat" sortable>-->
            <!--<template slot-scope="scope">CONT-{{scope.row.idContrat}}</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column prop="libelle" label="Nom" sortable></el-table-column>-->
            <!--<el-table-column prop="datePresence" label="Date de presence"></el-table-column>-->
            <!--<el-table-column prop="image" label="Image">-->
            <!--<template slot-scope="props">-->
            <!--<v-avatar-->
            <!--class="mr-2"-->
            <!--:tile="true"-->
            <!--size="100px"-->
            <!--height="100px"-->
            <!--color="grey lighten-4"-->
            <!--&gt;-->
            <!--<img :src="props.row.image" alt="avatar" />-->
            <!--</v-avatar>-->
            <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column label="Operations">-->
            <!--<template slot-scope="scope">-->
            <!--<v-tooltip top>-->
            <!--<v-btn-->
            <!--v-if="scope.row.disableBtnPres"-->
            <!--slot="activator"-->
            <!--fab-->
            <!--small-->
            <!--icons-->
            <!--color="red"-->
            <!--@click.native.prevent="presenceSelect=scope.row;dialogSuprPresence = true"-->
            <!--dark-->
            <!--&gt;-->
            <!--<v-icon center>delete</v-icon>-->
            <!--</v-btn>Supprimer-->
            <!--</v-tooltip>-->
            <!--</template>-->
            <!--</el-table-column>-->
            <!--</el-table>-->
            <!--</v-layout>-->
            <!--<br />-->
            <!--</v-card>-->
            <!--</v-flex>-->

            <!--&lt;!&ndash; bouton validation &ndash;&gt;-->
            <!--</v-layout>-->
            <!-- FIN ENREGISTRER UN PRESENCE -->

            <!--BOUTON VALIDATION-->
            <v-layout row class="text-xs-right"></v-layout>
          </v-card-text>
          <div style="flex: 1 1 auto;"></div>
        </v-card>
      </v-dialog>
      <!--MODAL LISTE OUVRIERS FIN -->

      <!-- MODAL SUPPRESSION DEMANDE -->
      <v-dialog v-model="dialogSuprPresence" persistent max-width="50%">
        <v-card>
          <v-card-title class="headline"
            >Supprimer cet enregistrement ?</v-card-title
          >
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 class="mb-2">
                <el-alert
                  title="La suppression est définitive"
                  :closable="false"
                  show-icon
                  type="error"
                ></el-alert>
              </v-flex>
              <v-flex xs12>
                <p class="grey--text font-weight-thin body-1">
                  OUVRIER/PRESTATAIRE
                </p>
                <p class="black--text .font-weight-regular subheading">
                  {{ presenceSelect.libelle }}
                </p>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="grey darken-1"
              dark
              @click="dialogSuprPresence = false"
            >
              Annuler
              <v-icon right>remove_circle</v-icon>
            </v-btn>
            <v-btn
              v-if="this.tacheSelect.etat != 2"
              color="red darken-1"
              dark
              @click="deletePresence(presenceSelect.idPresence)"
            >
              Supprimer
              <v-icon right>delete</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- MODAL DEMARRER TACHE -->
      <v-dialog v-model="dialogDemarrer" max-width="600" :persistent="true">
        <v-card tile>
          <v-toolbar card dark color="primary">
            <v-toolbar-title
              >Démarrer une tâche: {{ tacheSelect.libelle }}</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-btn icon dark @click.native="dialogDemarrer = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <el-form
              id="formDemarrer"
              label-width="90px"
              :model="formDemarrer"
              ref="formDemarrer"
              class="demo-form-inline"
            >
              <el-form-item label="Debut" required>
                <el-col :span="11">
                  <el-form-item prop="dateDbt">
                    <el-date-picker
                      type="date"
                      placeholder="Choisir une date de debut"
                      format="dd-MM-yyyy"
                      v-model="formDemarrer.dateDbt"
                      style="width: 100%;"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-form-item prop="hrDbt">
                    <el-time-picker
                      type="fixed-time"
                      placeholder="Choisir une heure de debut"
                      v-model="formDemarrer.hrDbt"
                      style="width: 100%;"
                    ></el-time-picker>
                  </el-form-item>
                </el-col>
              </el-form-item>

              <el-form-item class="text-xs-right">
                <v-btn color="grey" @click="resetForm('formDemarrer')" dark>
                  Annuler
                  <v-icon right>remove_circle</v-icon>
                </v-btn>
                <v-btn
                  icons
                  dark
                  color="green"
                  @click="submitFormDemarrer('formDemarrer')"
                >
                  Enregistrer
                  <v-icon right>add</v-icon>
                </v-btn>
              </el-form-item>
            </el-form>
          </v-card-text>
          <div style="flex: 1 1 auto;"></div>
        </v-card>
      </v-dialog>
      <!-- MODAL DEMARRER TACHE-->

      <!-- MODAL STOP TACHE -->
      <v-layout row justify-center>
        <v-dialog v-model="dialogConfirmRefus" persistent max-width="500">
          <v-card>
            <v-card-title class="headline"
              >Arreter la tâche: {{ tacheSelect.libelle }}</v-card-title
            >
            <v-card-text>
              <el-form
                id="formRefus"
                ref="formRefus"
                label-position="top"
                :inline="true"
                :model="formRefus"
                class="demo-form-inline"
              >
                <v-flex xs12>
                  <el-form-item
                    style="width:100%"
                    label="Voulez vous Arreter la tâche ?"
                  >
                    <el-input
                      style="width:100%"
                      type="textarea"
                      :rows="6"
                      placeholder="Pourquoi voulez-vous Arreter cette tâche ?"
                      v-model="formRefus.rapport"
                    ></el-input>
                  </el-form-item>
                </v-flex>
              </el-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                flat
                @click.native="dialogConfirmRefus = false"
                >Annuler</v-btn
              >
              <v-btn
                color="green darken-1"
                flat
                @click="submitFormStop('formRefus')"
                >Confirmer</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
      <!-- MODAL STOP TACHE-->

      <!-- MODAL TACHE TERMINE -->
      <v-layout row justify-center>
        <v-dialog v-model="dialogTermine" persistent max-width="500">
          <v-card>
            <v-card-title class="headline"
              >Tâche terminée: {{ tacheSelect.libelle }}</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                flat
                @click.native="dialogTermine = false"
                >Annuler</v-btn
              >
              <v-btn color="green darken-1" flat @click="submitTacheTerminer()"
                >Confirmer</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
      <!-- MODAL TACHE TERMINE-->
    </v-dialog>

    <!-- AJOUTER RESERVE-->
    <AjoutReserve
      :tache="tacheSelect"
      :show="showAddReserve"
      @close="closeAjoutReserve()"
    ></AjoutReserve>
    <!-- AJOUTER RESERVE -->
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import AjoutReserve from "@/components/rapport/AjoutReserve";

export default {
  components: { Loading, AjoutReserve },
  name: "IndexTache",
  props: {
    show: {
      type: Boolean
    },
    detailTrx: {
      type: Object
    },
    commis: {
      type: Boolean
    }
  },
  data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      dialogTache: false,
      loading: false,
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      listeTache: [],
      dialogOuvrier: false,
      dialogDemarrer: false,
      dialogConfirmRefus: false,
      listePrestataires: [],
      listePrestOuvriers: [],
      listePresence: [],
      listeOuvriers: [],
      formRefus: {},
      presenceSelect: {},
      tacheSelect: {
        libelle: ""
      },
      dialogTermine: false,
      formDemarrer: {},
      prestataireSelect: {
        idContrat: null,
        datePresence: null,
        file: null
      },
      tablePrestataire: [],
      dialogSuprPresence: false,
      imageRes: "/static/avatar-conducteur.png",

      //ajout reserve
      showAddReserve: false
    };
  },
  methods: {
    //reserve
    closeAjoutReserve() {
      this.showAddReserve = false;
    },

    showDialogReserve(item) {
      this.tacheSelect = item;
      this.showAddReserve = true;
    },

    closeDialog() {
      this.$emit("close");
    },
    loadTache(trx) {
      this.loading = true;
      let url = this.domaine + "tache/travaux/" + trx.idTrx;
      this.$http.get(url).then(
        response => {
          this.listeTache = response.body.taches;
          this.loading = false;
        },
        error => {
          this.loading = false;
          this.$message.error("Echec lors du chargement des taches");
        }
      );
    },
    loadOuvrier(tache) {
      this.prestataireSelect.datePresence = null;
      prestataireSelect.idContrat = null;
      this.loading = true;
      let url = this.domaine + "ouvrier/optionTravaux/" + tache.idOptTrx;
      this.$http.get(url).then(
        response => {
          this.listeOuvriers = response.body.ouvriers;
          this.listePrestataires = response.body.prestataires;
          this.listePrestOuvriers = response.body.listePresOuvriers;
          this.listePresence = response.body.listePresence;
          this.dialogOuvrier = true;
          this.loading = false;
        },
        error => {
          this.loading = false;
          this.$message.error("Echec lors du chargement des ouvriers");
        }
      );
    },
    submitFormDemarrer(formName) {
      if (
        this.formDemarrer.dateDbt != "undefined" &&
        this.formDemarrer.hrDbt != null &&
        this.formDemarrer.hrDbt != "undefined" &&
        this.formDemarrer.hrDbt != null
      ) {
        this.loading = true;
        let url =
          this.domaine +
          "tache/demarrer/optionTrx/" +
          this.tacheSelect.idOptTrx;
        let data = new FormData();

        let dateDbt =
          this.formDemarrer.dateDbt.getFullYear() +
          "-" +
          (this.formDemarrer.dateDbt.getMonth() + 1) +
          "-" +
          this.formDemarrer.dateDbt.getDate();

        let hrDbt =
          this.formDemarrer.hrDbt.getHours() +
          ":" +
          this.formDemarrer.hrDbt.getMinutes();

        data.append("dateDbt", dateDbt);
        data.append("idUser", this.user.id);
        data.append("hrDbt", hrDbt);
        this.$http.post(url, data).then(
          response => {
            this.loading = false;
            //reinitialiser le formulaire
            this.dialogDemarrer = false;

            let mess = response.body.message;
            this.loadTache(this.detailTrx);
            this.$notify({
              title: "ENREGISTREMENT REUSSI",
              message: mess,
              type: "success",
              position: "top-center"
            });
          },
          erreur => {
            //reinitialiser le formulaire
            this.resetForm("formDemarrer");
            this.loading = false;
            this.$message.error("L'opération a echouée");
          }
        );
      } // verifie champs date
      else {
        this.$message.error(
          "Veuillez remplir correctement la date et l'heure svp..."
        );
      }
    },
    submitFormStop(formName) {
      if (
        this.formRefus.rapport != "undefined" &&
        this.formRefus.rapport != null
      ) {
        this.loading = true;
        let url =
          this.domaine +
          "tache/arret/stop/tachetrx/" +
          this.tacheSelect.idOptTrx;
        let data = new FormData();

        data.append("idUser", this.user.id);
        data.append("rapport", this.formRefus.rapport);

        this.$http.post(url, data).then(
          response => {
            //reinitialiser le formulaire
            this.loading = false;
            this.dialogConfirmRefus = false;
            this.formRefus.rapport = "";
            let mess = response.body.message;
            this.loadTache(this.detailTrx);

            this.$notify({
              title: "ENREGISTREMENT REUSSI",
              message: mess,
              type: "success",
              position: "top-center"
            });
          },
          erreur => {
            //reinitialiser le formulaire
            this.formRefus.rapport = "";
            this.loading = false;
            this.$message.error("L'opération a echouée");
          }
        );
      } //rapport non saisie
      else {
        this.$message.error("Veuillez remplir correctement les champs svp...");
      }
    },

    submitRelanceTache() {
      this.loading = true;
      let url =
        this.domaine + "tache/relance/optionTrx/" + this.tacheSelect.idOptTrx;
      let data = new FormData();
      data.append("idUser", this.user.id);
      this.$http.post(url, data).then(
        response => {
          //reinitialiser le formulaire
          this.loading = false;

          let mess = response.body.message;
          this.$emit("reloadListeTravaux");
          this.loadTache(this.detailTrx);

          this.$notify({
            title: "ENREGISTREMENT REUSSI",
            message: mess,
            type: "success",
            position: "top-center"
          });
        },
        erreur => {
          this.loading = false;
          this.$message.error("L'opération a echouée");
        }
      );
    },

    submitTacheTerminer() {
      this.loading = true;
      let url =
        this.domaine + "tache/termine/optionTrx/" + this.tacheSelect.idOptTrx;
      let data = new FormData();
      data.append("idUser", this.user.id);
      this.$http.post(url, data).then(
        response => {
          //reinitialiser le formulaire
          this.loading = false;
          this.dialogTermine = false;

          let mess = response.body.message;
          this.loadTache(this.detailTrx);

          this.$notify({
            title: "ENREGISTREMENT REUSSI",
            message: mess,
            type: "success",
            position: "top-center"
          });
        },
        erreur => {
          this.loading = false;
          this.$message.error("L'opération a echouée");
        }
      );
    },

    submitPresence() {
      if (
        this.prestataireSelect.idContrat == null ||
        this.prestataireSelect.idContrat == "undefined" ||
        this.prestataireSelect.datePresence == "undefined" ||
        this.prestataireSelect.datePresence == null
      ) {
        this.$message.error("Veuillez renseigner correctement les champs");
        return;
      }
      ///this.loading = true;
      let url = this.domaine + "presence/new";
      let data = new FormData();
      data.append("idUser", this.user.id);
      data.append("idContrat", this.prestataireSelect.idContrat);
      data.append("datePresence", this.prestataireSelect.datePresence);
      data.append(
        "fichierRes",
        this.prestataireSelect.file,
        this.prestataireSelect.file[name]
      );

      this.$http.post(url, data).then(
        response => {
          //reinitialiser le formulaire

          this.loading = false;
          let mess = response.body.message;
          this.imageRes = "/static/avatar-conducteur.png";

          this.$notify({
            title: "ENREGISTREMENT REUSSI",
            message: mess,
            type: "success",
            position: "top-center"
          });

          this.loadOuvrier(this.tacheSelect);
          this.loading = false;
        },
        erreur => {
          this.loading = false;
          this.$message.error("L'opération a echouée");
        }
      );
    },

    deletePresence(idPresence) {
      this.loading = true;

      let url = this.domaine + "presence/delete/" + idPresence;
      this.$http.get(url).then(
        response => {
          this.loading = false;

          this.$notify({
            title: "SUPPRESSION REUSSIE",
            message: "Demande supprimée avec succès.",
            type: "success",
            position: "top-center"
          });
          this.dialogSuprPresence = false;

          this.loadOuvrier(this.tacheSelect);
        },
        errRep => {
          this.loading = false;
          this.dialogSuprPresence = false;
          this.$notify.error({
            title: "SUPPRESSION ECHOUEE",
            message: "La suppression de la demande a échouée.",
            position: "top-center"
          });
        }
      );
    },
    onFileResPicked(event) {
      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }
      if (files[0].size > 1048576) {
        this.$message.error("La taille du fichier est supérieur à 1024 ko");
        return;
      }

      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.imageRes = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.prestataireSelect.file = files[0];
      //this.file = files[0];
    }
  },

  watch: {
    show: function(newValue, oldvalue) {
      this.dialogTache = newValue;

      if (newValue) {
        this.loadTache(this.detailTrx);
      }
    }
  }
};
</script>

<style lang="stylus">
.list__tile__title {
  height: 600px;
}

.list {
  height: 600px;
}
</style>



// WEBPACK FOOTER //
// src/components/boardChantier/index_tache_chantier.vue